import React, { useCallback, useEffect } from "react";
import { useFormik } from "formik";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  useGetProductsQuery,
  useGetRegionsQuery,
  useGetActivitiesQuery,
  useGetPosTerminalTypesQuery,
  useGetPhonePrefixesQuery,
} from "../../api";
import { fetchCreateApplication } from "../../api/application.api";
import { Input } from "../../components/simple/Input";
import { history, PRODUCTS_IMG_URLS } from "../../helpers/history";
import i18n from "../../i18n";
import { ApplicationValidation } from "./validationSchema";
import { LbSelect } from "../../components/simple/LbSelect";
import { Icon } from "../../components/simple/Icon";
import { Column, Grid, Row } from "carbon-components-react";
import { Phone } from "../../components/simple/Phone";
import LbCheckBox from "../../components/simple/LbCheckBox";
import { LbToolTip } from "../../components/simple/LbToolTip";

export const ApplicationCreate = () => {
  // const {
  //   state: { posTerminalType = null },
  // } = useLocation();
  const { data, isLoading, isError, error } = useGetProductsQuery();

  // console.log("content", useGetProductsQuery());

  const {
    data: options,
    isError: isRegionError,
    isLoading: isRegionLoading,
  } = useGetRegionsQuery();
  const {
    data: activities,
    isError: isActivityError,
    isLoading: isActivityLoading,
  } = useGetActivitiesQuery();

  const {
    data: terminalOptions,
    isLoading: isTerminalOptionLoading,
    isTerminalOptionError,
  } = useGetPosTerminalTypesQuery();

  const { data: phoneOptions, isLoading: isPhoneOptionsLoading } =
    useGetPhonePrefixesQuery();

  const formik = useFormik({
    initialValues: {
      productTypes: [],
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      companyCode: "",
      companyName: "",

      //

      regionCode: null,
      activityCodes: {},
      companyWebSite: "",
      posTerminalType: null,

      phonePrefixes: {
        code: "+995",
        country: "Georgia",
        exampleNumber: i18n.t("Common.Phone.Placeholder"),
        format: "(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
        id: "GE",
        label: "+995",
        value: "GE",
      },
      agree: false,
      enableCashback: true,
      //helpers
      billingActivityCode: null,
      cashbackActivityCode: null,
    },
    validationSchema: ApplicationValidation,
    onSubmit: async (values, methods) => {
      const { setSubmitting, resetForm } = methods;
      try {
        setSubmitting(false);
        await fetchCreateApplication({
          ...values,
          regionCode: values.regionCode && values.regionCode.value,
          posTerminalType:
            values.posTerminalType && values.posTerminalType.value,
        });

        history.push("/application/create/complete", {
          type: "success",
          productTypes: values.productTypes,
        });
        resetForm();
      } catch (error) {
        history.push("/application/create/complete", {
          type: "error",
          productTypes: values.productTypes,
        });
      }
    },
  });

  const handleToggleProduct = useCallback(
    async (product) => {
      const productTypes = [...formik.values.productTypes];

      if (productTypes.includes(product)) {
        await formik.setFieldValue(
          "productTypes",
          productTypes.filter((i) => i !== product)
        );
      } else {
        productTypes.push(product);
        await formik.setFieldValue("productTypes", productTypes);
      }
    },
    [formik]
  );

  const handleType = useCallback(
    async (val) => {
      await formik.setFieldValue("posTerminalType", val);
      await formik.setFieldTouched("posTerminalType", true);
    },
    [formik]
  );

  const handleRegion = useCallback(
    async (val) => {
      await formik.setFieldValue("regionCode", val);
      await formik.setFieldTouched("regionCode", true);
    },
    [formik]
  );
  const handleActivity = useCallback(
    async (val, product) => {
      const formikProperty = {
        BILLING: "billingActivityCode",
        CASHBACK: "cashbackActivityCode",
      };
      let { activityCodes } = formik.values;
      activityCodes[product] = val.value;
      await formik.setFieldValue("activityCodes", activityCodes);
      await formik.setFieldTouched("activityCodes", true);
      await formik.setFieldValue(formikProperty[product], val);
      await formik.setFieldTouched(formikProperty[product], true);
    },
    [formik]
  );
  const handlePrefix = useCallback(
    async (val) => {
      await formik.setFieldValue("phonePrefixes", val);
    },
    [formik]
  );
  const handelAgree = useCallback(
    async (e) => {
      await formik.setFieldValue("agree", !formik.values.agree);
    },
    [formik]
  );
  const handelEnableCashBack = useCallback(
    async (val) => {
      await formik.setFieldValue("enableCashback", val);
    },
    [formik]
  );

  const handleShowAllProducts = useCallback(async () => {
    if (!formik.values.productTypes.length) return;
    await formik.setFieldValue("showAllProducts", true);
  }, [formik]);

  useEffect(() => {
    if (i18n.language) {
      formik.setFieldValue("posTerminalType", null);
      formik.setFieldValue("regionCode", null);
      formik.setFieldValue("cashbackActivityCode", null);
      formik.setFieldValue("billingActivityCode", null);
    }
  }, [i18n.language]);
  console.log(formik.errors);
  return (
    <Grid>
      <Row>
        <Column lg={12}>
          <div className="lb-product-selection mr-auto ml-auto">
            {/* Application ტერმინალი */}
            <div className="mb-64">
              <h4 className="productive-heading-08 mb-24">
                <Trans i18nKey="Application.Pos.Title" />
              </h4>
              <p className="lb-product-selection__text mb-80">
                <Trans i18nKey="Application.Pos.Description" />
              </p>
              <div className="img-container">
                {PRODUCTS_IMG_URLS.map(
                  (product) =>
                    data.includes(product.key) && (
                      <div className="card" key={`product-${product.key}`}>
                        <img src={product.img} alt="" />
                        <p>
                          <Trans
                            i18nKey={`Application.Product.${product.key}`}
                          />
                        </p>
                        <label className="card__checkbox">
                          <input
                            type="checkbox"
                            name="productType[]"
                            value={product.key}
                            onClick={() => handleToggleProduct(product.key)}
                            checked={formik.values.productTypes.includes(
                              product.key
                            )}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    )
                )}
              </div>

              {/* <button
                  className="btn btn-black btn-request btn-next display-mobile"
                  type="button"
                  
                  onClick={handleShowAllProducts}>
                  <Trans i18nKey="Common.Next" />
                </button> */}
            </div>

            {formik.values.productTypes.length ? (
              <div className="la-electronic-commerce mr-auto ml-auto">
                {/* <div className="la-electronic-commerce__row"> */}
                <Input
                  label={i18n.t("Application.contactName")}
                  value={formik.values.contactName}
                  onChange={formik.handleChange("contactName")}
                  onBlur={formik.handleBlur("contactName")}
                  error={
                    "contactName" in formik.errors &&
                    "contactName" in formik.touched
                  }
                />

                <Phone
                  phoneOptions={phoneOptions}
                  isLoading={isLoading}
                  label={i18n.t("Application.Pos.contactPhone")}
                  placeholder={
                    (formik.values.phonePrefixes &&
                      formik.values.phonePrefixes.exampleNumber) ||
                    i18n.t("Application.Pos.contactPhone.Placeholder")
                  }
                  name="contactPhone"
                  value={formik.values.contactPhone}
                  prefixValue={formik.values.phonePrefixes}
                  onChange={formik.handleChange("contactPhone")}
                  onPrefixChange={handlePrefix}
                  onBlur={formik.handleBlur("contactPhone")}
                  error={
                    "contactPhone" in formik.errors &&
                    "contactPhone" in formik.touched
                  }
                />
                {/* </div> */}
                {/* <div className="la-electronic-commerce__row"> */}
                <Input
                  label={i18n.t("Application.contactEmail")}
                  value={formik.values.contactEmail}
                  type={'email'}
                  onChange={formik.handleChange("contactEmail")}
                  onBlur={formik.handleBlur("contactEmail")}
                  error={
                    "contactEmail" in formik.errors &&
                    "contactEmail" in formik.touched
                  }
                />
                {formik.values.productTypes.includes("POS") && (
                  <LbSelect
                    options={options}
                    isLoading={isRegionLoading}
                    label={i18n.t("Application.Pos.regionCode")}
                    value={formik.values.regionCode}
                    onChange={handleRegion}
                    onBlur={formik.handleBlur("regionCode")}
                    error={
                      "regionCode" in formik.errors &&
                      "regionCode" in formik.touched
                    }
                    // menuIsOpen={true}
                    placeholder={i18n.t("Application.Pos.regionCode")}
                  />
                )}

                {formik.values.productTypes.includes("POS") && (
                  <div className="pos-terminal-type">
                    <LbSelect
                      options={
                        terminalOptions &&
                        terminalOptions.map((i) => ({
                          label: i18n.t(`Application.Pos.${i}`),
                          value: i,
                        }))
                      }
                      isLoading={isTerminalOptionLoading}
                      label={i18n.t("Application.Pos.TerminalType")}
                      value={formik.values.posTerminalType}
                      onChange={handleType}
                      onBlur={formik.handleBlur("posTerminalType")}
                      onClick={formik.handleBlur("posTerminalType")}
                      error={
                        "posTerminalType" in formik.errors &&
                        "posTerminalType" in formik.touched
                      }
                      placeholder={i18n.t("Application.Pos.TerminalType")}
                    />
                  </div>
                )}

                <Input
                  label={i18n.t("Application.companyName")}
                  value={formik.values.companyName}
                  onChange={formik.handleChange("companyName")}
                  onBlur={formik.handleBlur("companyName")}
                  error={
                    "companyName" in formik.errors &&
                    "companyName" in formik.touched
                  }
                />
                {/* </div> */}
                {/* <div className="la-electronic-commerce__row"> */}
                <Input
                  label={i18n.t("Application.companyCode")}
                  value={formik.values.companyCode}
                  onChange={formik.handleChange("companyCode")}
                  onBlur={formik.handleBlur("companyCode")}
                  error={
                    "companyCode" in formik.errors &&
                    "companyCode" in formik.touched
                  }
                  placeholder={i18n.t("Application.companyCode.Placeholder")}
                />

                {/* </div> */}
                {/* <div className="la-electronic-commerce__row"> */}
                {(formik.values.productTypes.includes("ECOMERCE") ||
                  formik.values.productTypes.includes("CASHBACK")) && (
                  <Input
                    regex="[a-zA-Z]"
                    label={i18n.t("Application.companyWebSite")}
                    value={formik.values.companyWebSite}
                    onChange={formik.handleChange("companyWebSite")}
                    onBlur={formik.handleBlur("companyWebSite")}
                    error={
                      "companyWebSite" in formik.errors &&
                      "companyWebSite" in formik.touched
                    }
                  />
                )}
                {/* <div className="la-electronic-commerce__row"> */}
                {formik.values.productTypes.includes("CASHBACK") && (
                  <LbSelect
                    options={
                      activities &&
                      activities.filter((i) => i.productType === "CASHBACK")
                    }
                    isLoading={isActivityLoading}
                    label={i18n.t("Application.CashBack.activityCodes")}
                    value={formik.values.cashbackActivityCode}
                    onChange={(val) => handleActivity(val, "CASHBACK")}
                    onBlur={formik.handleBlur("cashbackActivityCode")}
                    placeholder={i18n.t(
                      "Application.CashBack.activityCodes.Hint"
                    )}
                    // menuIsOpen={true}
                  />
                )}
                {formik.values.productTypes.includes("BILLING") && (
                  <LbSelect
                    options={
                      activities &&
                      activities.filter((i) => i.productType === "BILLING")
                    }
                    isLoading={isActivityLoading}
                    label={i18n.t("Application.BILLING.activityCodes")}
                    value={formik.values.billingActivityCode}
                    onChange={(val) => handleActivity(val, "BILLING")}
                    onBlur={formik.handleBlur("billingActivityCode")}
                    // menuIsOpen={true}
                    placeholder={i18n.t("Application.BILLING.activityCodes")}
                  />
                )}

                {!formik.values.productTypes.includes("CASHBACK") &&
                  (formik.values.productTypes.includes("POS") ||
                    formik.values.productTypes.includes("ECOMERCE")) && (
                    <div className="cashback-request">
                      <div>
                        <p className="description">
                          {i18n.t("Application.Pos.EnableCashBack")}
                        </p>
                        <i className="icn" id="information1">
                          <Icon name="information" viewBox="0 0 20 20" />
                        </i>

                        <LbToolTip
                          forId="information1"
                          html={i18n.t(
                            "Application.Pos.EnableCashBack.Tooltip"
                          )}
                          place="right"
                        />
                      </div>
                      <div className="cashback-request--btns">
                        <label className="container mr-26">
                          {i18n.t("Common.Yes")}
                          <input
                            type="radio"
                            name="radio"
                            onClick={() => handelEnableCashBack(true)}
                            checked={formik.values.enableCashback}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="container">
                          {i18n.t("Common.No")}
                          <input
                            type="radio"
                            name="radio"
                            onClick={() => handelEnableCashBack(false)}
                            checked={!formik.values.enableCashback}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    </div>
                  )}

                <div className="agreement-terms mb-32">
                  <p className="agreement-terms__details code-02">
                    {i18n.t("Application.Pos.AgreeRules")}
                  </p>
                  <LbCheckBox
                    id="Application.AcceptRules.agree"
                    i18nKey="Application.AcceptRules"
                    name="agree"
                    value={formik.values.agree}
                    checked={!!formik.values.agree}
                    onLabelClick={handelAgree}
                    onChange={handelAgree}
                    onBlur={formik.handleBlur("agree")}
                    error={
                      "agree" in formik.errors && "agree" in formik.touched
                    }
                  />
                </div>

                <button
                  className={`btn btn-black btn-request `}
                  type="button"
                  disabled={
                    !formik.dirty || formik.isSubmitting || !formik.isValid
                  }
                  onClick={formik.submitForm}
                >
                  <Trans i18nKey="Common.Create" />
                </button>
              </div>
            ) : null}
          </div>
        </Column>
      </Row>
    </Grid>
  );
};
